import {
  boxApply1qmzdb3dh90hg as boxApply,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Companion_instance1a0yry1hi33tg as Companion_instance } from './AbstractList.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IteratorImplClass;
function IteratorImpl() {
  if (IteratorImplClass === VOID) {
    class $ {
      constructor($outer, $box) {
        boxApply(this, $box);
        this.x6_1 = $outer;
        this.v6_1 = 0;
        this.w6_1 = -1;
      }
      v1() {
        return this.v6_1 < this.x6_1.v2();
      }
      w1() {
        if (!this.v1())
          throw NoSuchElementException().y6();
        var tmp = this;
        var _unary__edvuaz = this.v6_1;
        this.v6_1 = _unary__edvuaz + 1 | 0;
        tmp.w6_1 = _unary__edvuaz;
        return this.x6_1.w2(this.w6_1);
      }
      u6() {
        // Inline function 'kotlin.check' call
        if (!!(this.w6_1 === -1)) {
          var message = 'Call next() or previous() before removing element from the iterator.';
          throw IllegalStateException().o(toString(message));
        }
        this.x6_1.h5(this.w6_1);
        this.v6_1 = this.w6_1;
        this.w6_1 = -1;
      }
    }
    initMetadataForClass($, 'IteratorImpl');
    IteratorImplClass = $;
  }
  return IteratorImplClass;
}
var ListIteratorImplClass;
function ListIteratorImpl() {
  if (ListIteratorImplClass === VOID) {
    class $ extends IteratorImpl() {
      constructor($outer, index, $box) {
        if ($box === VOID)
          $box = {};
        $box.d7_1 = $outer;
        super($outer, $box);
        Companion_instance.e7(index, this.d7_1.v2());
        this.v6_1 = index;
      }
      f7() {
        return this.v6_1 > 0;
      }
      g7() {
        if (!this.f7())
          throw NoSuchElementException().y6();
        var tmp = this;
        this.v6_1 = this.v6_1 - 1 | 0;
        tmp.w6_1 = this.v6_1;
        return this.d7_1.w2(this.w6_1);
      }
    }
    initMetadataForClass($, 'ListIteratorImpl');
    ListIteratorImplClass = $;
  }
  return ListIteratorImplClass;
}
var SubListClass;
function SubList() {
  if (SubListClass === VOID) {
    class $ extends AbstractMutableList() {
      static l7(list, fromIndex, toIndex) {
        var $this = this.m7();
        $this.i7_1 = list;
        $this.j7_1 = fromIndex;
        $this.k7_1 = 0;
        Companion_instance.k6($this.j7_1, toIndex, $this.i7_1.v2());
        $this.k7_1 = toIndex - $this.j7_1 | 0;
        return $this;
      }
      g5(index, element) {
        Companion_instance.e7(index, this.k7_1);
        this.i7_1.g5(this.j7_1 + index | 0, element);
        this.k7_1 = this.k7_1 + 1 | 0;
      }
      w2(index) {
        Companion_instance.n7(index, this.k7_1);
        return this.i7_1.w2(this.j7_1 + index | 0);
      }
      h5(index) {
        Companion_instance.n7(index, this.k7_1);
        var result = this.i7_1.h5(this.j7_1 + index | 0);
        this.k7_1 = this.k7_1 - 1 | 0;
        return result;
      }
      o3(index, element) {
        Companion_instance.n7(index, this.k7_1);
        return this.i7_1.o3(this.j7_1 + index | 0, element);
      }
      o7(fromIndex, toIndex) {
        this.i7_1.o7(this.j7_1 + fromIndex | 0, this.j7_1 + toIndex | 0);
        this.k7_1 = this.k7_1 - (toIndex - fromIndex | 0) | 0;
      }
      v2() {
        return this.k7_1;
      }
      t6() {
        return this.i7_1.t6();
      }
    }
    initMetadataForClass($, 'SubList', VOID, VOID, [AbstractMutableList(), RandomAccess()]);
    SubListClass = $;
  }
  return SubListClass;
}
var AbstractMutableListClass;
function AbstractMutableList() {
  if (AbstractMutableListClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static m7() {
        var $this = this.r6();
        $this.z6_1 = 0;
        return $this;
      }
      n2(element) {
        this.t6();
        this.g5(this.v2(), element);
        return true;
      }
      f5() {
        this.t6();
        this.o7(0, this.v2());
      }
      u1() {
        return new (IteratorImpl())(this);
      }
      y2(element) {
        return this.w4(element) >= 0;
      }
      w4(element) {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var _iterator__ex2g4s = this.u1();
          while (_iterator__ex2g4s.v1()) {
            var item = _iterator__ex2g4s.w1();
            if (equals(item, element)) {
              tmp$ret$1 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$1 = -1;
        }
        return tmp$ret$1;
      }
      a3(index) {
        return new (ListIteratorImpl())(this, index);
      }
      g3(fromIndex, toIndex) {
        return SubList().l7(this, fromIndex, toIndex);
      }
      o7(fromIndex, toIndex) {
        var iterator = this.a3(fromIndex);
        // Inline function 'kotlin.repeat' call
        var times = toIndex - fromIndex | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            iterator.w1();
            iterator.u6();
          }
           while (inductionVariable < times);
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtList()) : false))
          return false;
        return Companion_instance.p7(this, other);
      }
      hashCode() {
        return Companion_instance.q7(this);
      }
    }
    initMetadataForClass($, 'AbstractMutableList', VOID, VOID, [AbstractMutableCollection(), KtMutableList()]);
    AbstractMutableListClass = $;
  }
  return AbstractMutableListClass;
}
//region block: exports
export {
  AbstractMutableList as AbstractMutableList192xfq8ycgofs,
};
//endregion

//# sourceMappingURL=AbstractMutableListJs.mjs.map
